import { FunctionComponent } from "react";
import { Navigate } from "react-router-dom";

import { useQuoteRequestData } from "#app/routes/pages/quote-requests/useQuoteRequestData";
import { QuoteRequestLinesPage } from "#modules/quoteRequestLines/QuoteRequestLines.page";
import { ROUTES } from "#shared/routes";
import { Loader } from "#shared/view/components/Loader";

export const QuoteRequestsPage: FunctionComponent = () => {
  const { user, isUserLoading, areQuoteRequestsLoading } = useQuoteRequestData();

  if (isUserLoading || areQuoteRequestsLoading) {
    return <Loader />;
  }

  if (!user) {
    return <Navigate to={ROUTES.login} />;
  }

  return <QuoteRequestLinesPage />;
};
